import { store } from "@/store";
import { getTokenInStorage } from "@/classes/MobileStorage";
import { normalizeAPIError, normalizeFetchError } from "@/services/apiErrors";

async function buildHeaders(headers = {}, token = null) {
    const nextHeaders = new Headers(headers);
    if (!nextHeaders.has("Content-Type")) {
        nextHeaders.set("Content-Type", "application/json");
    }
    nextHeaders.set("Customer-ID", store.getters.domain);
    if (token) {
        nextHeaders.set("Authorization", `Bearer ${token}`);
    }
    return nextHeaders;
}

export async function authenticatedFetch(url, options = {}, authService = null) {
    const execute = async (token) => {
        const headers = await buildHeaders(options.headers, token);
        return fetch(url, { ...options, headers });
    };

    try {
        let token = await getTokenInStorage();
        let response = await execute(token);

        if (response.status === 401 && authService) {
            token = await authService.refreshAccessToken();
            response = await execute(token);
        }

        if (!response.ok) {
            throw await normalizeFetchError(response);
        }

        return response;
    } catch (error) {
        throw normalizeAPIError(error);
    }
}

export async function authenticatedFetchJSON(url, options = {}, authService = null) {
    const response = await authenticatedFetch(url, options, authService);
    return response.json();
}
